import { defaultConfigs, version } from "@/settings";

const getDefaultSettings = () => {
  const settings = JSON.parse(JSON.stringify(defaultConfigs));
  return settings;
};

const settings = {
  state: {...getDefaultSettings()},

  getters: {
    version: () => version,
    locale: state => state.locale,
    drawerShow: state => state.drawer.show,
    drawerDense: state => state.drawer.dense,
    drawerLogo: state => state.drawer.logo,
    overlayLoading: state => state.overlayLoading
  },

  mutations: {
    DRAWER_TOGGLE: (state, payload) => {
      if (payload) state.drawer.show = payload.state;
      else state.drawer.show = !state.drawer.show;
    },
    SET_OVERLAY_LOADING: (state, showStatus) => {
      state.overlayLoading = showStatus;
    },
    SET_LOCALE: (state, lang) => {
      state.locale = lang;
    }
  },

  actions: {
    DrawerToggle: async ({ commit }, payload) => {
      commit("DRAWER_TOGGLE", payload);
    },
    setOverlayLoading: async ({ commit }, showStatus) => {
      commit("SET_OVERLAY_LOADING", showStatus);
    },
    setLocale: async ({ commit }, lang) => {
      commit("SET_LOCALE", lang);
    }
  }
};

export default settings;
